const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.extend(
    'swag-migration-profile-shopware54-api-page-information',
    'swag-migration-profile-shopware-api-page-information',
    {},
);

